import SvgIcon from 'common/components/svg-icon';


const ListIcon = (props) => (
    <SvgIcon
        height='24'
        viewBox='0 0 400 320'
        width='24'
        { ...props }>
        <path d='M126.58,30.83H384.8a15.2,15.2,0,0,0,0-30.39H126.58a15.2,15.2,0,0,0,0,30.39ZM50.65.44H15.2a15.2,15.2,0,0,0,0,30.39H50.65a15.2,15.2,0,1,0,0-30.39ZM384.8,147.34H126.58a15.2,15.2,0,0,0,0,30.39H384.8a15.2,15.2,0,0,0,0-30.39Zm-334.15,0H15.2a15.2,15.2,0,0,0,0,30.39H50.65a15.2,15.2,0,1,0,0-30.39ZM384.8,289.17H126.58a15.2,15.2,0,0,0,0,30.39H384.8a15.2,15.2,0,0,0,0-30.39Zm-334.15,0H15.2a15.2,15.2,0,0,0,0,30.39H50.65a15.2,15.2,0,1,0,0-30.39Z' />
    </SvgIcon>
);


export default ListIcon;



// WEBPACK FOOTER //
// ./src/common/components/svg-icon/list.js